var React = require('react');

function Loading (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 10.1355C2 14.4789 5.58172 18 10 18C14.4183 18 18 14.4789 18 10.1355C18 8.05393 17.1774 6.16126 15.8343 4.75449C15.1382 4.02533 14.3022 3.42671 13.3684 3","stroke":"currentColor","strokeWidth":"4"}));
}

Loading.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none"};

module.exports = Loading;

Loading.default = Loading;
